import {Component, Input, Output, EventEmitter, ChangeDetectionStrategy} from '@angular/core';
import {Action} from 'src/app/models/layout';

@Component({
	selector: 'app-custom-toolbar-actions',
	templateUrl: './custom-toolbar-actions.component.html',
	styleUrls: ['./custom-toolbar-actions.component.scss']
})
export class CustomToolbarActionsComponent
{
	@Input() actions: Action[] | null = null;
	@Input() detailId: string = '';
	@Output() action = new EventEmitter<string>();

	onClick(actionId: string): void
	{
		console.log('CUSTOM TOOLBAR ACTION', actionId);
		this.action.emit(actionId);
	}
}
